// IntegrationView.jsx

import { GetValuesRender } from './commonViews';

import React from 'react';
import PropTypes from 'prop-types';

const IntegrationView = props => {
    const { data } = props;

    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">
                    Integration Section Data
                </h1>
                <div className="form-section">
                    <GetValuesRender data={data} isNestedRenderingAllowed />
                </div>
            </div>
        </>
    );
};

IntegrationView.propTypes = {
    data: PropTypes.object,
};

export default IntegrationView;
